if (!customElements.get('pickup-availability')) {
  customElements.define(
    'pickup-availability',
    class PickupAvailability extends HTMLElement {
      constructor() {
        super();

        this.errorHtml = this.querySelector('template')?.content.firstElementChild.cloneNode(true);
        this.info = this.querySelector('.js-pickup-availability-info');
        this.pickupAvailabilityConfirmStore = this.querySelector('.pickup-availability__confirm-store');
        this.storeLocator = document.querySelector('my-store-locator');
        this.storeLocatorDrawer = document.querySelector('my-store-locator-drawer');
        this.storeConfirmationMessage = window.cartStrings.storeConfirmationMessage;
      }

      renderError() {
        this.info.innerHTML = '';
        this.info.append(this.errorHtml);
      }

      renderLoading() {
        this.info.innerHTML = '';
        if (this.pickupAvailabilityConfirmStore) this.pickupAvailabilityConfirmStore.innerHTML = '';
        const loadingHtml = `
          <p class="caption">
            ${this.storeLocator.dataset.loadingText} <i class="fa fa-spinner fa-spin"></i>
          </p>
        `;
        const loadingNode = new DOMParser().parseFromString(loadingHtml, 'text/html').body.childNodes[0];
        this.info.append(loadingNode);
      }

      renderPreview(location) {
        if (this.dataset?.cto) {
          if (this.dataset.excludeFromHib === 'true') {
            this.classList.remove('is-active');
            return;
          }
          if (location?.available && location?.quantityAvailable > 0) {
            this.classList.add('is-active');
          } else {
            this.classList.remove('is-active');
          }
          return;
        }

        if (this.dataset?.itemKey && location) {
          const itemLocationsData = this.storeLocator.itemLocationsData[this.dataset.itemKey];
          if (itemLocationsData) {
            const itemLocation = itemLocationsData.find((itemLocation) => itemLocation.id === location.id);
            if (itemLocation) {
              location = itemLocation;
            }
          }
        }

        let bundleAvailable = true;

        const selectedBundle = document.querySelector('input.js-cto-set-price-display:checked')

        if (selectedBundle) {
          const selectedBundleSecondaryProductId = selectedBundle.dataset.pairedProductId;

          const selectedBundleSecondaryProductLocationData = this.storeLocator.locationsData
            ?.find((item) => item.productId.includes(selectedBundleSecondaryProductId))?.locationData;

          const selectedBundleSecondaryProductLocation = selectedBundleSecondaryProductLocationData
            ?.find((item) => item.id === location.id)

          if ((selectedBundleSecondaryProductLocation && !selectedBundleSecondaryProductLocation.available) || !selectedBundleSecondaryProductLocation) {
            bundleAvailable = false;
          }
        }

        if (window.location.href.includes('/cart') && this.dataset?.itemKey) {
          const itemKey = this.dataset?.itemKey;
          const bundleSecondaryProductElement = document.querySelector(`[data-item-key="secondary${itemKey}"]`)

          if(bundleSecondaryProductElement) {
            const bundleSecondaryProductKey = bundleSecondaryProductElement.dataset.itemKey;
            const bundleSecondaryProductLocationsData = this.storeLocator.itemLocationsData[bundleSecondaryProductKey];
            const bundleSecondaryProductLocation = bundleSecondaryProductLocationsData.find((itemLocation) => itemLocation.id === location.id);

            if ((bundleSecondaryProductLocation && !bundleSecondaryProductLocation.available) || !bundleSecondaryProductLocation) {
              bundleAvailable = false;
            }
          }
        }

        this.info.innerHTML = '';
        if (this.pickupAvailabilityConfirmStore) this.pickupAvailabilityConfirmStore.innerHTML = '';
        let buttonText = this.storeLocator.dataset.viewStoreAvailabilityText;
        let unavailableHtml = '';
        let timeHtml = '';
        let stockHtml = '';
        let messageOverridden = false;
        const excludeFromHib = this.dataset.excludeFromHib === 'true';

        if (excludeFromHib) {
          if (location) { buttonText = location.name; }
          const excludedText = this.storeLocator.dataset.excludedFromHibText;
          unavailableHtml = `
            <p class="caption unavailable apl-section-pickup-availability-unavailable">
              ${excludedText}
            </p>
          `;
          if (location && location.quantityAvailable > 0 && location.quantityAvailable < 10) {
            const stockText = this.storeLocator.dataset.lowStockHtml.replace('{{ quantity }}', location.quantityAvailable);
            stockHtml = `
              <p class="caption">
                <span class="pickup-availability__stock apl-section-pickup-availability-stock">
                  ${stockText}
                </span>
              </p>
            `;
          }
        } else if (location) {
          const itemsAdded = this.dataset?.itemQuantity ? parseInt(this.dataset.itemQuantity) : null;

          buttonText = location.name;

          let pickUpTimeTranslated = '';
          if (location.pickUpTime) {
            const key = location.pickUpTime;
            const languageKey = SDG.Data.language?.toLowerCase() || 'en';
            pickUpTimeTranslated = window.deliveryOptionsStrings?.[languageKey]?.[key] || location.pickUpTime;
          }

          let overridePickupMessage = this.dataset?.overridePickupMessage;
          const messageType = this.dataset?.messageType;
          if (!overridePickupMessage && messageType) {
            const languageKey = SDG.Data.language?.toLowerCase() || 'en';
            const pickupMessagesJson = JSON.parse(location.pickupMessages?.value || null);
            const pickupMessages = pickupMessagesJson?.[languageKey] || pickupMessagesJson?.['en'];
            switch(messageType) {
              case 'cto':
                overridePickupMessage = pickupMessages?.cto;
                break;
              case 'preorder':
                overridePickupMessage = pickupMessages?.preOrder;
                break;
              case 'in stock':
                overridePickupMessage = pickupMessages?.inStock;
                break;
            }
          }

          if (overridePickupMessage && location.productPickupOfferedAtLocation && !(messageType === 'in stock' && (!location.available || location.quantityAvailable === 0)) && bundleAvailable) {
            timeHtml = `
              <p class="caption">
                <span class="pickup-availability__time apl-section-pickup-availability-time">
                  ${overridePickupMessage}
                </span>
              </p>
            `;
            if (window.location.href.includes('/cart') && this.pickupAvailabilityConfirmStore) {
              this.pickupAvailabilityConfirmStore.innerHTML = this.storeConfirmationMessage;
            }
            messageOverridden = true;
          } else if (location.available && location.quantityAvailable > 0 && bundleAvailable) {
            this.dataset.quantityAvailable = location.quantityAvailable;

            timeHtml = `
              <p class="caption">
                <span class="pickup-availability__time apl-section-pickup-availability-time">
                  ${pickUpTimeTranslated}
                </span>
              </p>
            `;
            if (location.quantityAvailable < 10) {
              const stockText = this.storeLocator.dataset.lowStockHtml.replace('{{ quantity }}', location.quantityAvailable);
              stockHtml = `
                <p class="caption">
                  <span class="pickup-availability__stock apl-section-pickup-availability-stock">
                    ${stockText}
                  </span>
                </p>
              `;
            }
            if (itemsAdded && itemsAdded > location.quantityAvailable) {
              timeHtml = `
                <p class="caption">
                <span class="pickup-availability__error apl-section-pickup-availability-error">
                  ${this.dataset.error}
                </span>
                </p>
              `;
            }
            if (window.location.href.includes('/cart') && this.pickupAvailabilityConfirmStore) {
              this.pickupAvailabilityConfirmStore.innerHTML = this.storeConfirmationMessage;
            }
          } else if (location.available === false || location.quantityAvailable === 0 || bundleAvailable === false) {
            const overrideUnavailableMessage = this.dataset?.overrideUnavailableMessage;
            unavailableHtml = `
              <p class="caption unavailable apl-section-pickup-availability-unavailable">
                ${overrideUnavailableMessage ? (`<span class="pickup-availability__unavailable-override">${overrideUnavailableMessage}</span>`) : this.storeLocator.dataset.unavailableText}
              </p>
            `;
            messageOverridden = !!overrideUnavailableMessage;
          }
        }

        // Eplehuset override messaging if product is CTO
        // Only show CTO message if product is CTO AND store doesn't have stock available
        // If store has stock, show normal availability (already set above)
        // Exception: keyboard CTO always shows CTO message (stock is for Norwegian keyboards only)
        const productIsCto = this.dataset.productIsCto === 'true'
        const keyboardCto = window._keyboardCto === true || this.dataset.keyboardCto === 'true'
        const ctoInventoryMessage = this.dataset.ctoDeliveryMessage || 'Bestillingsvare: 2-4 uker'

        if (!excludeFromHib && productIsCto && (keyboardCto || !location || !location.available || location.quantityAvailable === 0)) {
          timeHtml = ''
          stockHtml = `
            <p class="caption">
              <span>
                ${ctoInventoryMessage}
              </span>
            </p>
          `
        }

        // Eplehuset override messaging if product is Bestillingsvare (Assortment L/K, not CTO)
        // Only show when this location is out of stock — replaces "ikke på lager" wording
        const productIsBestillingsvare = this.dataset.productIsBestillingsvare === 'true'
        const bestillingsvareMessage = this.dataset.bestillingsvareMessage || 'Bestillingsvare: Du mottar estimert leveringstid etter kjøp'

        if (productIsBestillingsvare && (!location || !location.available || location.quantityAvailable === 0)) {
          timeHtml = ''
          stockHtml = `
            <p class="caption">
              <span>
                ${bestillingsvareMessage}
              </span>
            </p>
          `
        }


        // Eplehuset custom check default location for shipping availability
        // const defaultLocationId = '74166141090'
        const defaultLocationId = this.storeLocator.dataset.epleDefaultLocationId;
        const rawLocationsData = this.storeLocator.rawLocationsData;
        
        const defaultLocationAvailability = rawLocationsData?.product0?.variantBySelectedOptions?.storeAvailability?.edges?.find((edge) => edge.node.location.id === `gid://shopify/Location/${defaultLocationId}`);

        // Build shipping stock HTML from quantity
        const getShippingStockHtml = (qty) => {
          if (qty > 0 && qty < 10) {
            return `<span class="pickup-availability__stock">${this.storeLocator.dataset.lowStockHtml.replace('{{ quantity }}', qty)}</span>`;
          } else if (qty >= 10) {
            return `<span class="pickup-availability__time">${this.storeLocator.dataset.highStockHtml.replace('{{ quantity }}', '10+')}</span>`;
          }
          return 'Ikke på lager';
        };

        // Only show CTO message if product is CTO AND there's no stock available
        // If stock is available, show "På lager" even for CTO products
        // Exception: keyboard CTO always shows CTO message (stock is for Norwegian keyboards only)
        let shippingInfo;
        const defaultLocationOos = !defaultLocationAvailability?.node?.available || defaultLocationAvailability?.node?.quantityAvailable === 0;
        if (productIsCto && (keyboardCto || defaultLocationOos)) {
          shippingInfo = ctoInventoryMessage;
        } else if (productIsBestillingsvare && defaultLocationOos) {
          shippingInfo = bestillingsvareMessage;
        } else {
          shippingInfo = getShippingStockHtml(defaultLocationAvailability?.node?.quantityAvailable || 0);
        }

        document.querySelectorAll('.eple_shipping_availability_status').forEach(element => {
          element.innerHTML = shippingInfo;
        });

        // Card #434: ETA delivery estimate — only relevant when out of stock at Nettlager
        // (default location). Hidden by default in Liquid; reveal per selected variant.
        document.querySelectorAll('.eple-eta-estimate').forEach((element) => {
          element.style.display = defaultLocationOos ? 'block' : 'none';
        });

        // Update cart item shipping quantity
        if (this.dataset?.itemKey) {
          const itemKey = this.dataset.itemKey;
          const itemProductData = rawLocationsData?.[`product${itemKey}`];
          const itemDefaultLocation = itemProductData?.variantBySelectedOptions?.storeAvailability?.edges?.find(
            (edge) => edge.node.location.id === `gid://shopify/Location/${defaultLocationId}`
          );
          const cartQtyEl = document.querySelector(`.js-cart-shipping-qty[data-item-key="${itemKey}"]`);
          if (cartQtyEl) {
            const itemQty = itemDefaultLocation?.node?.quantityAvailable || 0;
            if (itemQty === 0 && productIsBestillingsvare) {
              cartQtyEl.innerHTML = bestillingsvareMessage;
            } else {
              cartQtyEl.innerHTML = getShippingStockHtml(itemQty);
            }
          }
        }

        // EPL CUSTOM — toggle Notify Me trigger visibility based on default-warehouse stock.
        // CTO products never render the trigger (handled in snippets/notify-me-epl.liquid),
        // so we only need to act on non-CTO. Drive visibility off quantityAvailable, not
        // `available`, because continue-selling variants report available:true at zero stock.
        if (!productIsCto) {
          const qty = defaultLocationAvailability?.node?.quantityAvailable;
          const isOutOfStock = !qty || qty <= 0;
          document.querySelectorAll('[data-notify-me-epl]').forEach(element => {
            if (isOutOfStock) {
              element.removeAttribute('hidden');
            } else {
              element.setAttribute('hidden', '');
            }
          });
        }

        const infoHtml = `
          <div class="pickup-availability-info-details apl-section-pickup-availability">
            ${unavailableHtml}
            ${timeHtml}
            ${stockHtml}
            <button
              class="js-my-store-locator-drawer-btn pickup-availability-button link link--text apl-section-pickup-availability-cta"
              aria-haspopup="dialog"
              ${this.dataset?.itemKey ? `data-item-key="${this.dataset.itemKey}"` : ''}
            >
              <span class="underlined-text">${buttonText}</span>
              ${this.classList.contains('cto__pickup') ? `<i class="fa-solid fa-chevron-right cto-chevron"></i>` : ''}
            </button>
          </div>
        `;

        const infoNode = new DOMParser().parseFromString(infoHtml, 'text/html').body.childNodes[0];
        this.info.append(infoNode);

        if (messageOverridden) {
          this.classList.add('is-overridden');
        } else {
          this.classList.remove('is-overridden');
        }

        const button = this.querySelector('button');
        if (button) {
          button.addEventListener('click', (evt) => {
            evt.preventDefault();
            // set the location data to the item specific location data if it exists
            this.storeLocatorDrawer.selectedItemLocationsKey = null;
            if (this.dataset?.itemKey) {
              const selectedItemLocationsData = this.storeLocator.itemLocationsData[this.dataset.itemKey];
              if (selectedItemLocationsData) {
                this.storeLocatorDrawer.selectedItemLocationsKey = this.dataset.itemKey;
                this.storeLocatorDrawer.updateStoreDetails(selectedItemLocationsData, '');
              }
            }
            this.storeLocatorDrawer.show(evt.currentTarget);
          });
        }


      }
    }
  );
}
